(function () {
  if (navigator.webdriver) return;
  var sectionEl = document.querySelector('[data-ts-id]');
  if (!sectionEl) return;
  var id = sectionEl.getAttribute('data-ts-id');

  var SC = {
    'Alabama':['Birmingham','Montgomery','Huntsville','Mobile','Tuscaloosa','Dothan','Auburn','Hoover'],
    'Alaska':['Anchorage','Fairbanks','Juneau','Sitka','Ketchikan','Wasilla','Kenai','Kodiak'],
    'Arizona':['Phoenix','Tucson','Mesa','Chandler','Scottsdale','Glendale','Tempe','Peoria'],
    'Arkansas':['Little Rock','Fort Smith','Fayetteville','Springdale','Jonesboro','North Little Rock','Conway','Rogers'],
    'California':['Los Angeles','San Diego','San Jose','San Francisco','Fresno','Sacramento','Long Beach','Oakland'],
    'Colorado':['Denver','Colorado Springs','Aurora','Fort Collins','Lakewood','Thornton','Arvada','Westminster'],
    'Connecticut':['Bridgeport','New Haven','Hartford','Stamford','Waterbury','Norwalk','Danbury','New Britain'],
    'Delaware':['Wilmington','Dover','Newark','Middletown','Smyrna','Milford','Seaford','Georgetown'],
    'Florida':['Jacksonville','Miami','Tampa','Orlando','St. Petersburg','Hialeah','Tallahassee','Port St. Lucie'],
    'Georgia':['Atlanta','Columbus','Augusta','Savannah','Athens','Sandy Springs','Roswell','Macon'],
    'Hawaii':['Honolulu','Pearl City','Hilo','Kailua','Waipahu','Kaneohe','Mililani','Kahului'],
    'Idaho':['Boise','Meridian','Nampa','Idaho Falls','Pocatello','Caldwell',"Coeur d'Alene",'Twin Falls'],
    'Illinois':['Chicago','Aurora','Joliet','Naperville','Rockford','Springfield','Peoria','Elgin'],
    'Indiana':['Indianapolis','Fort Wayne','Evansville','South Bend','Carmel','Fishers','Bloomington','Hammond'],
    'Iowa':['Des Moines','Cedar Rapids','Davenport','Sioux City','Iowa City','Waterloo','Ames','West Des Moines'],
    'Kansas':['Wichita','Overland Park','Kansas City','Topeka','Olathe','Lawrence','Shawnee','Manhattan'],
    'Kentucky':['Louisville','Lexington','Bowling Green','Owensboro','Covington','Richmond','Georgetown','Florence'],
    'Louisiana':['New Orleans','Baton Rouge','Shreveport','Lafayette','Lake Charles','Kenner','Bossier City','Monroe'],
    'Maine':['Portland','Lewiston','Bangor','South Portland','Auburn','Biddeford','Sanford','Saco'],
    'Maryland':['Baltimore','Columbia','Germantown','Silver Spring','Waldorf','Glen Burnie','Ellicott City','Frederick'],
    'Massachusetts':['Boston','Worcester','Springfield','Cambridge','Lowell','Brockton','New Bedford','Lynn'],
    'Michigan':['Detroit','Grand Rapids','Warren','Sterling Heights','Lansing','Ann Arbor','Flint','Dearborn'],
    'Minnesota':['Minneapolis','Saint Paul','Rochester','Duluth','Bloomington','Brooklyn Park','Plymouth','Maple Grove'],
    'Mississippi':['Jackson','Gulfport','Southaven','Hattiesburg','Biloxi','Meridian','Tupelo','Olive Branch'],
    'Missouri':['Kansas City','Saint Louis','Springfield','Columbia','Independence',"Lee's Summit",'O\'Fallon','St. Joseph'],
    'Montana':['Billings','Missoula','Great Falls','Bozeman','Butte','Helena','Kalispell','Havre'],
    'Nebraska':['Omaha','Lincoln','Bellevue','Grand Island','Kearney','Fremont','Hastings','Norfolk'],
    'Nevada':['Las Vegas','Henderson','Reno','North Las Vegas','Sparks','Carson City','Fernley','Elko'],
    'New Hampshire':['Manchester','Nashua','Concord','Derry','Rochester','Salem','Dover','Merrimack'],
    'New Jersey':['Newark','Jersey City','Paterson','Elizabeth','Edison','Woodbridge','Lakewood','Toms River'],
    'New Mexico':['Albuquerque','Las Cruces','Rio Rancho','Santa Fe','Roswell','Farmington','Clovis','Hobbs'],
    'New York':['New York City','Buffalo','Rochester','Yonkers','Syracuse','Albany','New Rochelle','Cheektowaga'],
    'North Carolina':['Charlotte','Raleigh','Greensboro','Durham','Winston-Salem','Fayetteville','Cary','Wilmington'],
    'North Dakota':['Fargo','Bismarck','Grand Forks','Minot','West Fargo','Williston','Dickinson','Mandan'],
    'Ohio':['Columbus','Cleveland','Cincinnati','Toledo','Akron','Dayton','Parma','Canton'],
    'Oklahoma':['Oklahoma City','Tulsa','Norman','Broken Arrow','Lawton','Edmond','Moore','Midwest City'],
    'Oregon':['Portland','Salem','Eugene','Gresham','Hillsboro','Beaverton','Bend','Medford'],
    'Pennsylvania':['Philadelphia','Pittsburgh','Allentown','Erie','Reading','Scranton','Bethlehem','Lancaster'],
    'Rhode Island':['Providence','Cranston','Warwick','Pawtucket','East Providence','Woonsocket','Coventry','Cumberland'],
    'South Carolina':['Columbia','Charleston','North Charleston','Mount Pleasant','Rock Hill','Greenville','Summerville','Goose Creek'],
    'South Dakota':['Sioux Falls','Rapid City','Aberdeen','Brookings','Watertown','Mitchell','Yankton','Pierre'],
    'Tennessee':['Nashville','Memphis','Knoxville','Chattanooga','Clarksville','Murfreesboro','Franklin','Jackson'],
    'Texas':['Houston','San Antonio','Dallas','Austin','Fort Worth','El Paso','Arlington','Corpus Christi'],
    'Utah':['Salt Lake City','West Valley City','Provo','West Jordan','Orem','Sandy','Ogden','St. George'],
    'Vermont':['Burlington','Essex','South Burlington','Colchester','Rutland','Bennington','Brattleboro','Hartford'],
    'Virginia':['Virginia Beach','Norfolk','Chesapeake','Richmond','Newport News','Alexandria','Hampton','Roanoke'],
    'Washington':['Seattle','Spokane','Tacoma','Vancouver','Bellevue','Kent','Everett','Renton'],
    'West Virginia':['Charleston','Huntington','Morgantown','Parkersburg','Wheeling','Weirton','Fairmont','Martinsburg'],
    'Wisconsin':['Milwaukee','Madison','Green Bay','Kenosha','Racine','Appleton','Waukesha','Oshkosh'],
    'Wyoming':['Cheyenne','Casper','Laramie','Gillette','Rock Springs','Sheridan','Green River','Evanston']
  };

  var TITLES = [
    'Cut My Energy Bill in Half',
    'Worth Every Penny',
    'Quiet, Powerful, Reliable',
    'Never Going Back to Window Units',
    'Arrived Fast, Works Flawlessly',
    'Handles Any Weather Without Breaking a Sweat',
    'Year-Round Comfort, One System',
    'Saved Us Hundreds on Utilities',
    'Factory-Direct Pricing Is Unbeatable'
  ];

  var BODIES = [
    'Decided to ditch the old central system and I could not be more pleased. The mini split cools the whole ground floor in minutes, runs silently, and my power bill dropped by almost half after the first full month.',
    'I did my research for weeks before ordering and HVAC MORE came out on top every time. The heat pump arrived ahead of schedule, the installation guide was genuinely easy to follow, and it has not skipped a beat since day one.',
    'The build quality on this unit is impressive. Even on the hottest days it keeps the house comfortable without straining, and at night you would never know it is running. Customer service answered every question before I even ordered.',
    'We finally got rid of the window units we had been dragging out every summer. This mini split handles heating and cooling in one and the air quality in the house is noticeably better. Could not be happier with the switch.',
    'Ordered on a Thursday and it was on my porch by Monday. Everything was packaged well, nothing was damaged, and the setup manual is actually written in plain English. Running strong four months later with zero issues.',
    'Our region gets extreme heat in summer and harsh cold in winter and this heat pump handles both without complaint. Energy costs are down and the unit is so quiet the family does not even notice when it cycles on.',
    'One system for heating, cooling, and dehumidifying -- it does it all. We replaced a 20-year-old central unit and the difference in comfort and efficiency is immediately noticeable. The whole setup took less than a day.',
    'After three quotes from local HVAC companies I found the same unit at HVAC MORE for hundreds less. Had a contractor install it and now we are saving a significant amount every single month on the electric bill.',
    'Everything about the experience was easy. The website made it simple to find the right unit for our square footage, checkout was smooth, shipping was fast, and the mini split itself has performed beyond expectations since installation.'
  ];

  var ABBR_TO_STATE = {
    'AL':'Alabama','AK':'Alaska','AZ':'Arizona','AR':'Arkansas','CA':'California',
    'CO':'Colorado','CT':'Connecticut','DE':'Delaware','FL':'Florida','GA':'Georgia',
    'HI':'Hawaii','ID':'Idaho','IL':'Illinois','IN':'Indiana','IA':'Iowa',
    'KS':'Kansas','KY':'Kentucky','LA':'Louisiana','ME':'Maine','MD':'Maryland',
    'MA':'Massachusetts','MI':'Michigan','MN':'Minnesota','MS':'Mississippi','MO':'Missouri',
    'MT':'Montana','NE':'Nebraska','NV':'Nevada','NH':'New Hampshire','NJ':'New Jersey',
    'NM':'New Mexico','NY':'New York','NC':'North Carolina','ND':'North Dakota','OH':'Ohio',
    'OK':'Oklahoma','OR':'Oregon','PA':'Pennsylvania','RI':'Rhode Island','SC':'South Carolina',
    'SD':'South Dakota','TN':'Tennessee','TX':'Texas','UT':'Utah','VT':'Vermont',
    'VA':'Virginia','WA':'Washington','WV':'West Virginia','WI':'Wisconsin','WY':'Wyoming'
  };

  function normalizeRegion(r) {
    if (!r) return r;
    if (r.length === 2) return ABBR_TO_STATE[r.toUpperCase()] || r;
    return r;
  }

  var applied = false;

  function applyGeo(region, city) {
    if (applied) return;
    var cities = SC[region];
    if (!cities) return;
    var track = document.getElementById('hvac-ts-track-' + id);
    if (!track) return;
    applied = true;

    var headEl = document.getElementById('hvac-ts-heading-' + id);
    if (headEl) headEl.innerHTML = region.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;') + "'s trusted HVAC supplier<br>for homeowners &amp; contractors";

    Array.from(track.children).forEach(function(card, i) {
      var c = (i === 0 && city && city.trim()) ? city.trim() : cities[i % cities.length];
      var locEl   = card.querySelector('.hvac-ts__location');
      var titleEl = card.querySelector('.hvac-ts__quote-title');
      var bodyEl  = card.querySelector('.hvac-ts__body');
      if (locEl)   locEl.textContent   = c + ', ' + region;
      if (titleEl) titleEl.textContent = '‘' + region + ' – ' + TITLES[i % TITLES.length] + '’';
      if (bodyEl)  bodyEl.textContent  = BODIES[i % BODIES.length];
    });

    var sEl = document.getElementById('hvac-ts-section-' + id);
    if (sEl && sEl._hvacTsGoTo) sEl._hvacTsGoTo(0);
  }

  function tryCache() {
    try {
      var c = JSON.parse(sessionStorage.getItem('hvac_geo_v1') || 'null');
      if (c && c.region) {
        applyGeo(normalizeRegion(c.region), c.city || '');
        return applied;
      }
    } catch (e) {}
    return false;
  }

  function fetchGeo() {
    return fetch('https://ipapi.co/json/')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (d && d.region) return { region: normalizeRegion(d.region), city: d.city || '', postal: d.postal || '' };
        throw new Error('empty');
      })
      .catch(function() {
        return fetch('https://get.geojs.io/v1/ip/geo.json')
          .then(function(r) { return r.json(); })
          .then(function(d) {
            if (d && d.region) return { region: normalizeRegion(d.region), city: d.city || '', postal: '' };
            throw new Error('empty');
          });
      });
  }

  function init() {
    if (tryCache()) return;
    fetchGeo()
      .then(function(d) {
        var geo = { region: d.region || '', city: d.city || '', postal: d.postal || '', ts: Date.now() };
        try { sessionStorage.setItem('hvac_geo_v1', JSON.stringify(geo)); } catch(e) {}
        applyGeo(geo.region, geo.city);
      })
      .catch(function() {});
    var polls = 0;
    var poller = setInterval(function() {
      if (tryCache() || ++polls >= 20) clearInterval(poller);
    }, 500);
  }

  init();

  window.addEventListener('hvac:geo-change', function(e) {
    if (!e.detail || !e.detail.region) return;
    applied = false;
    applyGeo(normalizeRegion(e.detail.region), e.detail.city || '');
  });
})();
